export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="relative h-[520px] w-full md:h-[620px]">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20stylized%20manga%20illustration%20banner%2C%20group%20of%20anime%20heroes%20in%20dynamic%20action%20pose%20facing%20camera%2C%20bold%20ink%20outline%20and%20cel%20shading%2C%20coral%20red%20and%20amber%20gold%20energy%20glow%2C%20dark%20night%20skyline%20with%20city%20lights%20behind%2C%20speed%20lines%20and%20sparks%2C%20cinematic%20composition%2C%20high%20contrast%2C%20vibrant%20comic%20book%20art%20style%2C%20warm%20and%20energetic%20atmosphere&width=1600&height=900&seq=hero-manga-bg&orientation=landscape"
          alt="YY免费漫画 在线看无删减全集，热血漫画角色动态插画背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/70 to-background-900/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-transparent to-background-950/40" />

        <div className="relative z-10 mx-auto flex h-full w-full max-w-6xl flex-col justify-center px-4 py-20 md:px-6 lg:px-8">
          <p className="mb-4 inline-flex w-fit items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-3 py-1 text-xs text-primary-400">
            <i className="ri-flashlight-fill" />
            下拉式翻页 · 即开即读 · 高清不伤眼
          </p>
          <h1 className="font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
            海量免费漫画，<br className="hidden md:block" />
            随时随地<span className="text-primary-500">畅快开读</span>
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-700 md:text-base">
            热门连载、经典完结全集资源一站直达。无需下载，打开浏览器就能追；下拉式翻页流畅顺滑，高清画质时刻在线，享受不被打断的阅读时光。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-play-fill" />
              立即开始追漫
            </a>
            <a
              href="#genres"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-100/60 px-7 py-3 text-sm text-foreground-800 transition hover:border-accent-400/50 hover:text-accent-400"
            >
              <i className="ri-compass-3-line" />
              浏览题材分类
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-6 md:gap-10">
            <div>
              <p className="font-heading text-2xl text-accent-400">1800+</p>
              <p className="mt-1 text-xs text-foreground-600">海量连载书目</p>
            </div>
            <div className="h-8 w-px bg-background-300/60" />
            <div>
              <p className="font-heading text-2xl text-accent-400">99.9%</p>
              <p className="mt-1 text-xs text-foreground-600">高清画质资源</p>
            </div>
            <div className="h-8 w-px bg-background-300/60" />
            <div>
              <p className="font-heading text-2xl text-accent-400">24h</p>
              <p className="mt-1 text-xs text-foreground-600">更新不掉队</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}